import { ORDER_TYPE_DROPSHIP, ORDER_TYPE_REORDER } from '../constants/orderTypes';

export const dropshipProductsUtils = {
  getOrderTypeOptions,
  getOrderTypeOptionLabel,
  shouldShowOrderTypeOption,
  getCatalogueManagementProductUrl,
};

function getOrderTypeOptions() {
  return [ORDER_TYPE_DROPSHIP, ORDER_TYPE_REORDER].map((orderType) => ({
    label: getOrderTypeOptionLabel(orderType),
    value: orderType,
  }));
}

function getOrderTypeOptionLabel(orderType) {
  const orderTypeOptionLabelMap = {
    [ORDER_TYPE_DROPSHIP]: 'Order',
    [ORDER_TYPE_REORDER]: 'Reorder',
  };
  return orderTypeOptionLabelMap[orderType];
}

function shouldShowOrderTypeOption(orderTypeCounts) {
  return orderTypeCounts[ORDER_TYPE_REORDER] > 0;
}

function getCatalogueManagementProductUrl({ retailerId, model, params }) {
  return `/retailers/${retailerId}/catalogue-management/product/${model}${params}`;
}
